import api from "../../components/services/api";
import { useParams } from "react-router";
import { useMemo, useState } from "react";
import { useEffect } from "react";
import moment from "moment";
import { useLocation } from "react-router-dom";
import "./SaleOrder.css";
function useQuery() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}
export default function ApprovalExpenseForm() {
  const query = useQuery();
  const { id } = useParams();
  const [data, setData] = useState();

  const getCurrency = async () => {
    try {
      const res = await api.get(
        `api/report/cost-request-form/data?CostType=${query.get(
          "CostType"
        )}&CostId=${id}&CompanyCode=${query.get("CompanyCode")}`
      );
      setData(res.data);
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getCurrency();
  }, []);
  const pageCount = Math.ceil(data?.Detail?.length / 6);

  const rows = [];
  for (let pageIndex = 0; pageIndex < pageCount; pageIndex++) {
    rows.push(
      <>
        <page>
          {query.get("CompanyCode") === "STL" && (
            <div class="header">
              <img
                src="/images/logo2.png"
                class="logo"
                style={{ width: "145px" }}
              />
              <div className="header_title">
                <h3>SRITRANG LOGISTIC COMPANY LIMITED</h3>
                <h4>บริษัท ศรีตรังโลจิสติกส์ จำกัด</h4>
              </div>
            </div>
          )}
          {query.get("CompanyCode") === "STLB" && (
            <div class="header">
              <img
                src="/images/logo2.png"
                class="logo"
                style={{ width: "145px" }}
              />
              <div className="header_title">
                <h3>SRITRANG LANDBRIDGE COMPANY LIMITED</h3>
                <h4>บริษัท ศรีตรัง แลนบริด จำกัด</h4>
              </div>
            </div>
          )}
          {query.get("CompanyCode") === "APL" && (
            <div class="header">
              <img
                src="/images/logo2.png"
                class="logo"
                style={{ width: "145px" }}
              />
              <div className="header_title">
                <h3>APILOGISTICZ COMPANY LIMITED</h3>
                <h4>บริษัท อภิโลจิซทิคซ์ จำกัด</h4>
              </div>
            </div>
          )}
          {query.get("CompanyCode") === "SLEO" && (
            <div class="header">
              <img src="/images/logo3.png" class="logo" />
              <div className="header_title">
                <h3>SRITRANG LEO MULTIMODAL LOGISTICS COMPANY LIMITED</h3>
                <h4>บริษัท ศรีตรัง ลีโอ มัลติโมเดิล ลอจิสติกส์ จำกัด</h4>
              </div>
            </div>
          )}

          <div
            class="content"
            style={{
              marginTop: "0px",
              marginBottom: "0px",
              display: "flex",
              justifyContent: "end",
              borderTop: "1px solid #000",
            }}
          >
            <h4>ใบขออนุมัติเบิกเงินค่าใช้จ่าย</h4>
          </div>
          <div
            class="content"
            style={{ marginTop: "0px", justifyContent: "space-between" }}
          >
            <div className="rowR" style={{ display: "flex", flexBasis: "75%" }}>
              <p className="header_p" style={{ flexBasis: "5%", whiteSpace:'nowrap' }}>
                ผู้ขอเบิก:{" "}
              </p>
              <p style={{ flexBasis: "90%" }}> {data?.EmployeeName || "-"}</p>
            </div>
            <div className="rowR" style={{ display: "flex", flexBasis: "25%" }}>
              <p className="header_p">วันที่: </p>
              <p style={{ textAlign: "end" }}>
                {" "}
                {moment().format("DD/MM/YYYY")}
              </p>
            </div>
            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "100%" }}
            >
              <p className="header_p" style={{ flexBasis: "7.3%" }}>
                บริษัท:{" "}
              </p>
              <p style={{ flexBasis: "92.7%" }}>
                {" "}
                {data?.EmployeeCompany || "-"}
              </p>
            </div>
            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "100%" }}
            >
              <p className="header_p" style={{ flexBasis: "7.3%" }}>
                สาขา:{" "}
              </p>
              <p style={{ flexBasis: "92.7%" }}>
                {" "}
                {data?.EmployeeBranch || "-"}
              </p>
            </div>
            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "100%" }}
            >
              <p className="header_p" style={{ flexBasis: "7.3%" }}>
                หน่วยงาน:{" "}
              </p>
              <p style={{ flexBasis: "92.7%" }}>
                {" "}
                {data?.EmployeeDepartment || "-"}
              </p>
            </div>
            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "100%" }}
            >
              <p className="header_p" style={{ flexBasis: "7.3%" }}>
                ค่าใช้จ่าย:{" "}
              </p>
              <p style={{ flexBasis: "92.7%" }}> {data?.CostType || "-"}</p>
            </div>
            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "100%" }}
            >
              <p
                className="header_p"
                style={{ flexBasis: "10%", marginRight: "0px" }}
              >
                ผู้จัดจำหน่าย:{" "}
              </p>
              <p style={{ flexBasis: "90%" }}> {data?.SalerName || "-"}</p>
            </div>
            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "100%" }}
            >
              <p className="header_p" style={{ flexBasis: "40%" }}>
                เลขที่บัตรประชาชน/หนังสือเดินทาง/เลขที่ประจำตัวผู้เสียภาษี:{" "}
              </p>
              <p style={{ flexBasis: "60%" }}> {data?.SalerTaxId || "-"}</p>
            </div>
          </div>
          <div className="containerR">
            <table
              border="1"
              cellpadding="10"
              cellspacing="0"
              style={{ width: "100%" }}
            >
              <tr style={{ border: "1px solid" }}>
                <th style={{ border: "1px solid", width:'77px' }}>เลขที่ใบแจ้งหนี้</th>
                <th style={{ border: "1px solid" }}>รายการ</th>
                <th style={{ border: "1px solid",width:'45px' }}>จำนวน</th>
                <th style={{ border: "1px solid" }}>ราคา/หน่วย</th>
                <th style={{ border: "1px solid",width:'40px' }}>ภาษี%</th>
                <th style={{ border: "1px solid",width:'90px' }}>จำนวนเงิน</th>
                <th style={{ border: "1px solid",width:'46px'  }}>สกุลเงิน</th>
              </tr>

              <tr
                style={{
                  border: "1px solid",
                  fontSize: "16px",
                  height: "27px",
                }}
              >
                <td style={{ border: "1px solid" }}>{data?.InvoiceNo}</td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.Detail?.slice(pageIndex * 5, pageIndex * 5 + 5)[0]
                      ?.Charge
                  }
                </td>
                <td style={{ border: "1px solid" }}>
                  {data?.Detail?.slice(
                    pageIndex * 5,
                    pageIndex * 5 + 5
                  )[0]?.Quantity.toLocaleString()}
                </td>
                <td style={{ border: "1px solid" }} align="right">
                  {data?.Detail?.slice(
                    pageIndex * 5,
                    pageIndex * 5 + 5
                  )[0]?.PricePerUnit.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.Detail?.slice(pageIndex * 5, pageIndex * 5 + 5)[0]
                      ?.TaxPercent
                  }
                </td>
                <td style={{ border: "1px solid" }} align="right">
                  {data?.Detail?.slice(
                    pageIndex * 5,
                    pageIndex * 5 + 5
                  )[0]?.TotalAmountTHB && (+data?.Detail?.slice(
                    pageIndex * 5,
                    pageIndex * 5 + 5
                  )[0]?.TotalAmountTHB).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.Detail?.slice(pageIndex * 5, pageIndex * 5 + 5)[0]
                      ?.Currency
                  }
                </td>
              </tr>
              <tr
                style={{
                  border: "1px solid",
                  fontSize: "16px",
                  height: "27px",
                }}
              >
                <td style={{ border: "1px solid" }}></td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.Detail?.slice(pageIndex * 5, pageIndex * 5 + 5)[1]
                      ?.Charge
                  }
                </td>
                <td style={{ border: "1px solid" }}>
                  {data?.Detail?.slice(
                    pageIndex * 5,
                    pageIndex * 5 + 5
                  )[1]?.Quantity.toLocaleString()}
                </td>
                <td style={{ border: "1px solid" }} align="right">
                  {data?.Detail?.slice(
                    pageIndex * 5,
                    pageIndex * 5 + 5
                  )[1]?.PricePerUnit.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.Detail?.slice(pageIndex * 5, pageIndex * 5 + 5)[1]
                      ?.TaxPercent
                  }
                </td>
                <td style={{ border: "1px solid" }} align="right">
                  {data?.Detail?.slice(
                    pageIndex * 5,
                    pageIndex * 5 + 5
                  )[1]?.TotalAmountTHB && (+data?.Detail?.slice(
                    pageIndex * 5,
                    pageIndex * 5 + 5
                  )[1]?.TotalAmountTHB).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.Detail?.slice(pageIndex * 5, pageIndex * 5 + 5)[1]
                      ?.Currency
                  }
                </td>
              </tr>
              <tr
                style={{
                  border: "1px solid",
                  fontSize: "16px",
                  height: "27px",
                }}
              >
                <td style={{ border: "1px solid" }}></td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.Detail?.slice(pageIndex * 5, pageIndex * 5 + 5)[2]
                      ?.Charge
                  }
                </td>
                <td style={{ border: "1px solid" }}>
                  {data?.Detail?.slice(
                    pageIndex * 5,
                    pageIndex * 5 + 5
                  )[2]?.Quantity.toLocaleString()}
                </td>
                <td style={{ border: "1px solid" }} align="right">
                  {data?.Detail?.slice(
                    pageIndex * 5,
                    pageIndex * 5 + 5
                  )[2]?.PricePerUnit.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.Detail?.slice(pageIndex * 5, pageIndex * 5 + 5)[2]
                      ?.TaxPercent
                  }
                </td>
                <td style={{ border: "1px solid" }} align="right">
                  {data?.Detail?.slice(
                    pageIndex * 5,
                    pageIndex * 5 + 5
                  )[2]?.TotalAmountTHB && (+data?.Detail?.slice(
                    pageIndex * 5,
                    pageIndex * 5 + 5
                  )[2]?.TotalAmountTHB).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.Detail?.slice(pageIndex * 5, pageIndex * 5 + 5)[2]
                      ?.Currency
                  }
                </td>
              </tr>
              <tr
                style={{
                  border: "1px solid",
                  fontSize: "16px",
                  height: "27px",
                }}
              >
                <td style={{ border: "1px solid" }}></td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.Detail?.slice(pageIndex * 5, pageIndex * 5 + 5)[3]
                      ?.Charge
                  }
                </td>
                <td style={{ border: "1px solid" }}>
                  {data?.Detail?.slice(
                    pageIndex * 5,
                    pageIndex * 5 + 5
                  )[3]?.Quantity.toLocaleString()}
                </td>
                <td style={{ border: "1px solid" }} align="right">
                  {data?.Detail?.slice(
                    pageIndex * 5,
                    pageIndex * 5 + 5
                  )[3]?.PricePerUnit.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.Detail?.slice(pageIndex * 5, pageIndex * 5 + 5)[3]
                      ?.TaxPercent
                  }
                </td>
                <td style={{ border: "1px solid" }} align="right">
                  {data?.Detail?.slice(
                    pageIndex * 5,
                    pageIndex * 5 + 5
                  )[3]?.TotalAmountTHB && (+data?.Detail?.slice(
                    pageIndex * 5,
                    pageIndex * 5 + 5
                  )[3]?.TotalAmountTHB).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.Detail?.slice(pageIndex * 5, pageIndex * 5 + 5)[3]
                      ?.Currency
                  }
                </td>
              </tr>
              <tr
                style={{
                  border: "1px solid",
                  fontSize: "16px",
                  height: "27px",
                }}
              >
                <td style={{ border: "1px solid" }}></td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.Detail?.slice(pageIndex * 5, pageIndex * 5 + 5)[4]
                      ?.Charge
                  }
                </td>
                <td style={{ border: "1px solid" }}>
                  {data?.Detail?.slice(
                    pageIndex * 5,
                    pageIndex * 5 + 5
                  )[4]?.Quantity.toLocaleString()}
                </td>
                <td style={{ border: "1px solid" }} align="right">
                  {data?.Detail?.slice(
                    pageIndex * 5,
                    pageIndex * 5 + 5
                  )[4]?.PricePerUnit.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.Detail?.slice(pageIndex * 5, pageIndex * 5 + 5)[4]
                      ?.TaxPercent
                  }
                </td>
                <td style={{ border: "1px solid" }} align="right">
                  {data?.Detail?.slice(
                    pageIndex * 5,
                    pageIndex * 5 + 5
                  )[4]?.TotalAmountTHB && (+data?.Detail?.slice(
                    pageIndex * 5,
                    pageIndex * 5 + 5
                  )[4]?.TotalAmountTHB).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.Detail?.slice(pageIndex * 5, pageIndex * 5 + 5)[4]
                      ?.Currency
                  }
                </td>
              </tr>
              <tr style={{ border: "1px solid", fontSize: "16px" }}>
                <td
                  valign="top"
                  rowspan="4"
                  colspan="3"
                  style={{ border: "1px solid" }}
                >
                  <p style={{ marginBottom: "0px" }}>หมายเหตุ</p>
                  <span>{data?.remark || ""}</span>
                </td>
                <td colspan="2" style={{ border: "1px solid" }}>
                  จำนวนเงินก่อนภาษี
                </td>
                <td colspan="1" style={{ border: "1px solid" }} align="right">
                  {(+data?.AmountTHB).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </td>
                <td colspan="1" style={{ border: "1px solid" }}>
                  Baht
                </td>
              </tr>
              <tr style={{ border: "1px solid", fontSize: "16px" }}>
                <td colspan="2" style={{ border: "1px solid" }}>
                  ภาษีหัก ณ ที่จ่าย %
                </td>
                <td colspan="1" align="right">
                  {(+data?.WithholdingTaxAmountTHB).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </td>
                <td style={{ border: "1px solid" }}>Baht</td>
              </tr>
              <tr style={{ border: "1px solid", fontSize: "16px" }}>
                <td colspan="2" style={{ border: "1px solid" }}>
                  ภาษีมูลค่าเพิ่ม %
                </td>
                <td colspan="1" align="right">
                  {(+data?.TaxAmountTHB).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </td>
                <td style={{ border: "1px solid" }}>Baht</td>
              </tr>
              <tr style={{ border: "1px solid", fontSize: "16px" }}>
                <td colspan="2" style={{ border: "1px solid" }}>
                  จำนวนเงินจ่ายสุทธิ
                </td>
                <td colspan="1" align="right">
                  {(+data?.TotalAmountTHB).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </td>
                <td style={{ border: "1px solid" }}>Baht</td>
              </tr>
            </table>
          </div>
          <div
            className="content_footer"
            style={{ justifyContent: "space-between" }}
          >
            <div className="rowR" style={{ flexBasis: "30%" }}>
              <p style={{ lineHeight: "24px" }}>
                ______________________________
              </p>
              <p>(.........................................................)</p>
              <p>Responsibility</p>
              <p>Date.............../.............../...............</p>
            </div>
            <div className="rowR" style={{ flexBasis: "30%" }}>
              <p style={{ lineHeight: "24px" }}>
                ______________________________
              </p>
              <p>(.........................................................)</p>
              <p>Marketing Assistant Manager</p>
              <p>Date.............../.............../...............</p>
            </div>
            <div className="rowR" style={{ flexBasis: "30%" }}>
              <p style={{ lineHeight: "24px" }}>
                ______________________________
              </p>
              <p>(.........................................................)</p>
              <p>Marketing Manager</p>
              <p>Date.............../.............../...............</p>
            </div>
          </div>
        </page>
      </>
    );
  }
  return <>{rows}</>;
}
